/* global youbora */
youbora.registerAdapter('Ima', require('./adapter'))
module.exports = youbora
